var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "image-overlay"
  }, [_c('v-img', {
    staticClass: "image-overlay__logo mx-auto",
    attrs: {
      "src": "/images/ci.svg"
    }
  }), _c('p', {
    staticClass: "image-overlay__title page-text"
  }, [_vm._t("default")], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }